<template>
  <div class="tile tile--home">
    <h3 class="content__heading">{{ title }} Requests</h3>
    <div class="request--numbers">
      <router-link
        v-for="result in statusCounts"
        class="flex__between btn text__white link__none"
        :class="`status--${result.name}`"
        :key="result.id"
        :to="`/${url}?status=${result.name}`"
      >
        <span class="text__bold">{{ titleCase(result.name) }} Requests:</span>
        <span>{{ result.count }}</span>
      </router-link>
    </div>
    <div v-if="total === 0" class="chart flex__center border__small">No Data to Display</div>
    <PieChart v-else :chart-data="chartData" class="chart" />
    <DashRequest :request="lastRequest" :url="url" />
  </div>
</template>

<script>
import PieChart from "./PieChart";
import DashRequest from "./DashRequest";
export default {
  props: ["title", "total", "statusCounts", "chartData", "lastRequest", "url"],
  components: {
    PieChart,
    DashRequest
  },
  methods: {
    titleCase(value) {
      // only works for single word
      return value.split("")[0].toUpperCase() + value.slice(1);
    }
  }
};
</script>